/**
 * TeamChatWidget: dal 02/09/2026 la chat di team vive nel drawer unico
 * "Messaggi" (scheda Team). Questo componente resta montato nel Layout per due
 * cose: caricare chat e utenti dell'org, e reindirizzare chi apre ancora il
 * vecchio widget (widgetState) verso il drawer unico.
 */

import { useEffect } from 'react';
import { useTeamChatStore } from '../../lib/stores/teamChatStore';
import { useSettingsStore } from '../../lib/stores/settingsStore';
import { useAuth } from '../../lib/auth';
import { useWhatsAppDrawerStore } from '../../lib/stores/whatsappDrawerStore';

export function TeamChatWidget() {
  const { userProfile } = useAuth();
  const { fetchSettings } = useSettingsStore();
  const { widgetState, setWidgetState, fetchChats, fetchOrganizationUsers, selectedChatId } = useTeamChatStore();

  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  useEffect(() => {
    if (userProfile?.id) {
      fetchChats();
      fetchOrganizationUsers();
    }
  }, [userProfile?.id, fetchChats, fetchOrganizationUsers]);

  // Compatibilita': chi chiama ancora setWidgetState('expanded' | 'chat' | 'list')
  // (notifiche, store) apre il drawer unico sulla scheda Team.
  useEffect(() => {
    if (widgetState === 'minimized') return;
    useWhatsAppDrawerStore.getState().openTeamChat(selectedChatId);
    setWidgetState('minimized');
  }, [widgetState, selectedChatId, setWidgetState]);

  return null;
}
